/** This needs to look at the Action, provide a change object per combatant */
import {getDangerMeterChanges} from './description/danger-meter'
import {getPpChanges} from './description/pp'
import {getHpChanges} from './description/hp'
import {getStatusChanges} from './description/status'
import {getStatChanges} from './description/stats'
import {getItemChanges} from './description/items'
import {getStealingChanges} from './description/stealing'
import {getBuggingChanges} from './description/bugging'
import {getFail} from './description/fail'
import {getMiss} from './description/miss'
import {getFollowupsChanges} from './description/followups'
import {getCommitRevertStashChanges} from './description/commit-revert-stash'

export function getDescriptionObjectFromSubmission(actionModel, casterModel, targetModels=[], combatants) {

    //Establish the IDs of caster vs targets
    const combatantMap = {
        casterId: casterModel.id, //"c"
        targetIds: targetModels.map(targetModel => targetModel.id)   //["a", "b"]
    };

    //Create empty objects for each combatants to track state changes.
    //`description` functions will fill in these objects.
    let currentCombatantStateChanges = {
        state: {}, //the combatants new state that will get merged in
        description: {} //extra bit of data we need to capture (item stolen, damage done, was it effective, etc)
    };

    //Add Caster
    currentCombatantStateChanges.state[casterModel.id] = {};

    //Add Targets
    combatantMap.targetIds.forEach(targetId => {
        currentCombatantStateChanges.state[targetId] = {};
    });


    //Run our stateChanges object through our suite of `description` functions
    currentCombatantStateChanges = getDangerMeterChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants);
    currentCombatantStateChanges = getPpChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants);
    currentCombatantStateChanges = getFail(actionModel, combatantMap, currentCombatantStateChanges, combatants); //failing
    currentCombatantStateChanges = getMiss(actionModel, combatantMap, currentCombatantStateChanges, combatants); //missing
    currentCombatantStateChanges = getItemChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants); //remove item from inventory (effects of item are below)
    //Stop here if FAIL, MISS, or BUGGED
    if (currentCombatantStateChanges.didFail || currentCombatantStateChanges.didMiss || currentCombatantStateChanges.wasBugged) {
        return currentCombatantStateChanges
    }

    currentCombatantStateChanges = getHpChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants);
    currentCombatantStateChanges = getStatusChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants);
    currentCombatantStateChanges = getStatChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants);
    currentCombatantStateChanges = getStealingChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants);
    currentCombatantStateChanges = getBuggingChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants);
    currentCombatantStateChanges = getFollowupsChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants);
    currentCombatantStateChanges = getCommitRevertStashChanges(actionModel, combatantMap, currentCombatantStateChanges, combatants);

    return currentCombatantStateChanges;
}



// WEBPACK FOOTER //
// ./src/battle/lifecycle/get-description-object.js